import { Controller, useFormContext } from 'react-hook-form';
import { Box, InputLabel, TextField, Typography } from '@mui/material';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { inputStyles, errorInputBgStyles } from 'src/utils/style';

const toDigits = (value) => `${value ?? ''}`.replace(/[^\d]/g, '');

const withCommas = (value) => toDigits(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export function RHFDigitField({
  name,
  displayName,
  displayNameVariant = 'body_md',
  placeholder,
  helperText,
  disabled = false,
  maxLength,
  sx,
  ...other
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Box sx={{ width: '100%' }}>
          {displayName && (
            <InputLabel sx={{ color: 'text.primary' }}>
              <Typography
                variant={displayNameVariant}
                sx={{ color: 'text.primary' }}
              >
                {displayName}
              </Typography>
            </InputLabel>
          )}
          <TextField
            {...field}
            sx={{ ...inputStyles, ...errorInputBgStyles, ...sx }}
            fullWidth
            size="small"
            variant={disabled ? 'filled' : 'outlined'}
            disabled={disabled}
            placeholder={placeholder}
            value={withCommas(field.value)}
            onChange={(event) => {
              const digits = toDigits(event.target.value);
              field.onChange(maxLength ? digits.slice(0, maxLength) : digits);
            }}
            error={!!error}
            helperText={
              error ? (
                <Box
                  component="span"
                  sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}
                >
                  <ErrorOutlineOutlinedIcon sx={{ fontSize: '0.875rem' }} />
                  <span>{error?.message}</span>
                </Box>
              ) : (
                helperText
              )
            }
            {...other}
          />
        </Box>
      )}
    />
  );
}

export default RHFDigitField;
